let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4QiEy")).then(() => parcelRequire('bHdQ2'));